import createToolbar from './createToolbar';
import registerTools from './registerTools';
import { toolManager } from './toolManager';

const tools = {
    createToolbar,
    registerTools,
    toolManager,
};

export { tools };
